<div class="main-box">
  <div [formGroup]="guideForm">
      <p-button label="Submit" (onClick)="sendForm()"></p-button>
      <p *ngIf="nameIsNull">
        Name is required
      </p>
    <table>
      <tr>
          <td>
              Name
            </td>
            <td>
                <input placeholder="Name" type="text" formControlName="name">
            </td>
      </tr>
      <tr>
        <td>
          Comment
        </td>
        <td>
          <ckeditor [editor]="Editor" formControlName="comment"></ckeditor>
        </td>
      </tr>
    </table>
    </div>
</div>
